<template lang="pug">
  .component.component-backoffice-driver(v-if="item")
    .inner-content(v-if="$is('expanded')")
      p status: {{ item.status }}
      p expiry {{ item.expiry_date }}
      p issuer.by {{ item.issuer }}
      p issuer.date {{ item.issue_date }}
      p issuer_country {{ item.issuer_country }}
      button.button.secondary.block-button(
        type="button",
        v-for="(i, index) in item.attachments",
        v-on:click="openUrl(i.url)"
      ) {{ i.mime }}
    .license-card(v-if="$is('license-card')")
      span Driver License
      pre {{item}}
    .license-card-accordion(v-if="$is('license-card-accordion')")
      ul.accordion(data-accordion v-f="" data-allow-all-closed="true")
        li.accordion-item(data-accordion-item)
          a.accordion-title(href="#")
            .row
              .columns
                h3 {{ item.type.name }}
                h2(v-if="item.type.has_number") {{item.number}}
                p(v-if="item.type.has_issuer") ISSUED ON:
                  b {{ item.issue_date }}
                p(v-if="item.type.has_number") NUMBER:
                  b {{item.number }}
              .columns
                p
                  strong CREATED: {{item.created_at}}
                p(v-if="item.type.has_expiry")
                  strong EXPIRY DATE: {{ item.expiry_date }}
                p
                  strong STATUS: {{item.status}}
          div.accordion-content(data-tab-content)
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'").float-right
              .flex-container.flex-dir-column
                a.success-text(
                  v-if="item.status !== 'VALID'",
                  v-on:click="approve"
                ) Approve
                .warning-text(v-on:click="refuse") Refuse
                hr.dropdown-separator
                a.warning-text(v-on:click="edit") Edit
                a(v-on:click="upload") Upload
                a.alert-text(v-on:click="deleteD") Delete
            p(v-if="item.type.has_issuer") Issued by:
              b  {{ item.issuer }}
            p(v-if="item.type.has_country") Issuer country:
              b  {{item.issuer_country }}
            p(v-if="item.type.has_emission") Issued date:
              b  {{ item.issue_date }}
            p(v-if="item.type.has_number") Number:
              b  {{ item.number }}
            hr(v-if="item.attachments.length")
            p.text-center.alert-text.no-attachments(v-else) no attachments
            backoffice-driver-license-attachment(:item="item")
    .license-approval-list(v-if="$is('license-approval-list')")
      .card
        .inner-content
          CardN(:columns="4", :showAction="true", :showBullets="true")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'", slot="actionBullets")
              .flex-container.flex-dir-column
                a.success-text(
                  v-if="item.status !== 'VALID'",
                  v-on:click="approve"
                ) Approve
                .warning-text(v-on:click="refuse") Refuse
                hr.dropdown-separator
                a.warning-text(v-on:click="edit") Edit
                a(v-on:click="upload") Upload
                a.alert-text(v-on:click="deleteD") Delete
            span(slot="n1") D{{item.id}}
            driver-fields(slot="n1", :item="item.driver", :fieldName="'driver-info'")

            .document-info(slot="n2")
              span
                strong {{item.type.name}}
              span(v-if="item.type.has_number") Number: {{item.number}}
              span(v-if="item.type.has_expiry") Expiry: {{item.expiry_date}}
              span(v-if="item.type.has_emission") Emission: {{item.issue_date}}
            .document-info(slot="n3")
              span(v-if="item.type.has_issuer") Issuer: {{item.issuer}}
                span(v-if="item.type.has_country") &nbsp;{{item.issuer_country}}
              span Created: {{item.created_at}}
            .attachments(slot="actionPage", )
              span.fa(:class="attachmentButton", @click="showAttachments = !showAttachments")
      .attachments.inner-content(v-if="showAttachments")
        hr(v-if="item.attachments.length")
        p.text-center.alert-text.no-attachments(v-else) no attachments
        backoffice-driver-license-attachment(:item="item")
        .row.align-justify
          h3
            a.success-text(v-if="item.status !== 'VALID'", v-on:click="approve") Approve
          h3
            a.warning-text(v-on:click="refuse") Refuse
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import Driver from '../../components/backoffice/Driver'
  import Status from '../structure/ui/Status'
  import BackofficeAttachment from './Attachment'
  import MaggieHelper from 'src/maggieHelper'
  import DriverLicenseSmartEdit from 'components/backoffice/smartedits/DriverLicenseEdit'
  import BackofficeDriverLicenseAttachment from './DriverLicenseAttachment'
  import BackofficeDriverLicenseAttachmentUpload from './DriverLicenseAttachmentUpload'
  import Card4 from '../structure/Card4.vue'
  import Card3 from '../structure/Card3.vue'
  import Dropdown from '../structure/foundation/Dropdown'
  import CardN from '../structure/CardN'
  import Thumbnail from '../structure/thumbnail'
  import DriverFields from '../structure/ui/entity-fields/DriverFields'

  export default {
    components: {
      DriverFields,
      Thumbnail,
      CardN,
      Dropdown,
      Card3,
      Card4,
      BackofficeDriverLicenseAttachmentUpload,
      BackofficeDriverLicenseAttachment,
      BackofficeAttachment,
      Status,
      Driver,
    },
    name: 'DriverLicence',
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        showAttachments: false
      }
    },
    methods: {
      edit() {
        MaggieHelper.openRightPanel({
          component: DriverLicenseSmartEdit,
          props: {
            item: this.item
          }
        })
      },
      approve() {
        KeplerBackofficeSdk.driverLicenses.select(this.item).approve((data) => {
          location.reload()
        })
      },
      deleteD() {
        this.$confirm('Are you sure', `Do you want to delete DL${this.item.id} document?`, () => {
          KeplerBackofficeSdk.driverLicenses.select(this.item).delete((data) => {
            location.reload()
          })
        })
      },
      refuse() {
        KeplerBackofficeSdk.driverLicenses.select(this.item).refuse((data) => {
          location.reload()
        })
      },
      upload() {
        MaggieHelper.openRightPanel({
          component: BackofficeDriverLicenseAttachmentUpload,
          props: {
            item: this.item
          }
        })
      },
      openUrl: function (url) {
        window.open(url, '_blank')
      }
    },
    computed: {
      attachmentButton() {
        return this.showAttachments ? 'fa-minus' : 'fa-plus'
      }
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component.component-backoffice-driver
    .document-info
      display: flex
      flex-direction: column
    .attachments
      span
        cursor: pointer
    .block-button
      display: block

      .accordion-item a
        text-decoration: none

      .license-approval-list
        margin-bottom: 0

        ul
          margin-bottom: 0

        .accordion-title
          border: none

    .driver-approval-card > .card
      background: transparent
      display: flex
      flex-flow: row wrap

      .approve-reject
        justify-content: space-around

    hr.dropdown-separator
      border-top-width: thin
      margin: 1em 0

    .no-attachments
      margin: 1em 0
      padding: 1em
      border-top: 1px solid
</style>



// WEBPACK FOOTER //
// DriverLicence.vue?5a4d71d6